/**
 * @generated SignedSource<<4082eb9f065f9f4d69a10a006a95bc9d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AdminUserActionsActivateAffiliateMutation$variables = {
  affiliateName: string;
  userId: string;
};
export type AdminUserActionsActivateAffiliateMutation$data = {
  readonly activateAffiliate: {
    readonly affiliate: string | null;
    readonly id: string;
  } | null;
};
export type AdminUserActionsActivateAffiliateMutation = {
  response: AdminUserActionsActivateAffiliateMutation$data;
  variables: AdminUserActionsActivateAffiliateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "affiliateName"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "affiliateName",
        "variableName": "affiliateName"
      },
      {
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
      }
    ],
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "activateAffiliate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "affiliate",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminUserActionsActivateAffiliateMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AdminUserActionsActivateAffiliateMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "9d243d20d75760c888431f3441ea9bbc",
    "id": null,
    "metadata": {},
    "name": "AdminUserActionsActivateAffiliateMutation",
    "operationKind": "mutation",
    "text": "mutation AdminUserActionsActivateAffiliateMutation(\n  $userId: String!\n  $affiliateName: String!\n) {\n  activateAffiliate(userId: $userId, affiliateName: $affiliateName) {\n    id\n    affiliate\n  }\n}\n"
  }
};
})();

(node as any).hash = "f694b753fb6cba7cbe174d7dfb4aac2c";

export default node;
